export default __webpack_public_path__ + "static/media/data_setting_11.532ae346.png";